<ng-template>
  <mat-select></mat-select>
</ng-template>
